










import { computed, defineComponent, ref, toRefs } from '@vue/composition-api'
import { TagStyler } from '../../composables/useTagFormatter'
import { UITag } from '../../types/tag'
import { Word, WordTagStyles } from '../../models/word'

export default defineComponent({
  name: 'KaiSpace',
  props: {
    word: {
      type: Object as () => Word
    },
    wordIndex: {
      type: Number,
      required: true,
      default: 0
    },
    isEditable: {
      type: Boolean,
      required: true,
      default: false
    },
    tags: {
      type: Array as () => UITag[],
      required: true,
      default: () => []
    }
  },
  setup(props) {
    const { tags, wordIndex, isEditable } = toRefs(props)
    const bgColor = ref('')
    const isRoundedRight = ref(false)
    const isFullyBordered = ref(false)

    const styles = computed(() => {
      const tagStyles: WordTagStyles = TagStyler.computeStyles(
        tags.value,
        wordIndex.value
      )
      bgColor.value = !isEditable.value ? tagStyles.color || '' : ''

      if (!isEditable.value) {
        isRoundedRight.value = tagStyles.isRoundedRight || false
        isFullyBordered.value = tagStyles.isFullyBordered || false
      }

      return {
        space: true,
        'border-top-bottom':
          !isEditable.value &&
          (tagStyles.hasTopBottomBorder || tagStyles.isRoundedLeft)
      }
    })

    return {
      bgColor,
      styles,
      isRoundedRight,
      isFullyBordered
    }
  }
})
